import './NewBadgeComponent.scss';
export const NewComponent = () => {
	return (
		<div className='badge-new-container'>
			<span className='badge-new'>
				<span className='text-badge-new'>NEW!</span>
			</span>
		</div>
	);
};
